// extracted by mini-css-extract-plugin
export default {"EventDetailsHeader":"Styles_EventDetailsHeader__0qpwq","EventTitle":"Styles_EventTitle__onbpY"};